import { TFunction } from "@impero-com/common/utils/i18n";

import { AssignmentRow } from "./types";

interface RecipientCountTextProps {
    t: TFunction;
    assignmentRow: AssignmentRow;
    numberOfUserRecipients: number;
    numberOfGroupRecipients: number;
}

export function getRecipientsTooltipText({
    t,
    assignmentRow,
    numberOfUserRecipients,
    numberOfGroupRecipients,
}: RecipientCountTextProps): string | null {
    const userText =
        numberOfUserRecipients > 0
            ? t("Control_NotifyUsers_TooltipDescriptionActive", {
                  count: numberOfUserRecipients,
              })
            : null;
    const groupText =
        numberOfGroupRecipients > 0
            ? t("Control_NotifyGroups_TooltipDescriptionActive", {
                  count: numberOfGroupRecipients,
              })
            : null;

    if (assignmentRow.notify) {
        if (userText && groupText) {
            return t("Control_Notify_TooltipDescriptionActive", {
                userText: t("Control_NotifyUsers", {
                    count: numberOfUserRecipients,
                }),
                groupText: t("Control_NotifyGroups", {
                    count: numberOfGroupRecipients,
                }),
            });
        } else {
            return (
                userText ||
                groupText ||
                t("Control_Notify_TooltipDescriptionInactive")
            );
        }
    } else {
        return t("Control_Notify_TooltipDescriptionInactive");
    }
}
